import { useState, useEffect } from 'react';
import moment from 'moment';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { DynamicObjectInterface } from '../../../../sdk/type';
import {
  // DropDown,
  Input,
  InputTypes,
  RadioButton,
  MLPVersion,
  Theme,
  ButtonStyles,
  //DropDown,
  TextArea,
  DatePicker,
  TableContainer,
  Card,
  Modal,
  Button,
  ButtonTypes,
  ButtonSize,
  TextAlign,
  Checkbox,
  SearchComponent,
} from '../../../../ui/components';
import ShareDrawer from '../../../../ui/components/DrawerAlt/ShareDrawer';
import { LoggerService, dateTimeToCustomFormat, formatISODate } from '../../../../ui/utils';
import { useAdminToast } from '../../../../ui/components/AdminToast/AdminToast';
import { ParticipantDataStructure, TeamData } from '../teamsListConfig';
import getParticipantListConfig from '../participantListConfig';
//import getParticipantListConfigMobile from '../participantListConfigMobile';
//import { DropDownData } from '../../../../ui/components/Form/DropDown/types/propsType';
import { DropdownOption, InputValidations } from '../../../../ui/components/Form/SearchComponent/types/propTypes';
import TeamService from '../../../../sdk/services/teamService';
import CoachService from '../../../../sdk/services/coachService';
import AuditLogService from '../../../../sdk/services/auditLogService';
import AcknowledgementService from '../../../../sdk/services/acknowlegementService';
import ParticipantService from '../../../../sdk/services/participantService';
import { getRoundedNumber } from '../../../../ui/utils/common';
import { decryptString } from '../../../../ui/utils/cryptoUtils';
import OperationCenterErrorCard, {
  ErrorType,
} from '../../../../ui/components/OperationCenterErrorCard/OperationCenterErrorCard';
import { useAPICall } from '../../../../hooks';
import styles from '../index.module.scss';
import AuditHistoryAccordion from '../../audit-log/auditLogAccordion';

export const initTeamForm: TeamData = {
  teamId: null,
  teamName: '',
  description: '',
  campaignId: '',
  campaignRecId: null,
  campaignName: '',
  campaignStart: '',
  campaignEnd: '',
  teamLeader: '',
  isIndividualTeam: null,
  coachId: '',
  teamStartDate: '',
  teamEndDate: '',
  status: '',
  isDeleted: false,
};

interface AcknowledgePayload {
  userId: string | undefined;
  campaignId: string | undefined;
  teamId: number | null;
  name: string | undefined;
  action: string;
  acknowledgeDateTime: string | null | undefined;
  remarks: string;
}

export const AdminTeamEditPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { adminToast } = useAdminToast();
  const apiCall = useAPICall();
  const id = searchParams.get('');
  const [coachList, setCoachList] = useState<{ id: string; title: string }[]>([]);
  const [filteredCoachList, setFilteredCoachList] = useState(coachList);
  // const [teamLeaderList, setTeamLeaderList] = useState<{ value: string; title: string }[]>([]);
  const [teamData, setTeamData] = useState<TeamData>(initTeamForm);
  const [showShareDrawer, setShowShareDrawer] = useState(false);
  const [joinTeamLink, setJoinTeamLink] = useState<string>('');
  //const [campaignRecId, setCampaignRecId] = useState<string>('');
  const [selectedRow, setSelectedRow] = useState<ParticipantDataStructure | null>(null);
  const [participantList, setParticipantList] = useState<ParticipantDataStructure[]>([]);
  const [displayEmpty, setDisplayEmpty] = useState(false);
  const [confirmCheck, setConfirmCheck] = useState(false);
  const [showAcknowledgment, setShowAcknowledgment] = useState(false);
  const [remarksWeightIn, setRemarksWeightIn] = useState('');
  const [remarksWeightOut, setRemarksWeightOut] = useState('');
  const [isWeightInAcknowledged, setIsWeightInAcknowledged] = useState(false);
  const [isWeightOutAcknowledged, setIsWeightOutAcknowledged] = useState(false);
  const [auditHistoryLog, setAuditHistoryLog] = useState([]);
  const [displayAuditEmpty, setAuditDisplayEmpty] = useState(false);
  const [showAllWeightIn, setShowAllWeightIn] = useState(false);
  const [showAllWeightOut, setShowAllWeightOut] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const ipadDimensions = useMediaQuery('(max-width:960px) and (min-width:768px)');
  //const smallerScreens = useMediaQuery('(max-width:1280px) and (min-width:961px)');
  // Use useEffect to update userData when id changes

  useEffect(() => {
    (async () => {
      const result = await apiCall(TeamService.getTeamDetails, `${id}`);
      if (result.status === 200) {
        let data = result.data.data;
        setTeamData(data ?? initTeamForm);
        if (data.campaignId && data.teamId) {

          if (data.campaignId){
            const coachListResult =  await apiCall(CoachService.getEnrolledCoachByCampaign, data.campaignId);
            if (coachListResult.data.data) {
              setCoachList(
                coachListResult.data.data?.map((d: DynamicObjectInterface) => ({ id: d.coachId, title: `${d.coachId} - ${d.name}` })),
              );
            } else {
              LoggerService.log('Failed to retrieve coach list');
            }
          }

          const payload = {
            campaignId: data.campaignId,
            teamId: data.teamId?.toString(),
          };
          const result = await apiCall(ParticipantService.getTeamParticipants, payload);
          if (result.status === 200) {
            const participantsWithAcknowledgement = result.data.data?.map((participant: DynamicObjectInterface) => ({
              ...participant,

              acknowledgement: participant.weightIn?.acknowledgeDateTime && participant.weightOut?.acknowledgeDateTime,
              weightIn: {
                ...participant.weightIn,
                bodyFat: participant?.weightIn?.bodyFat
                  ? getRoundedNumber(parseFloat(decryptString(participant?.weightIn?.bodyFat)))
                  : 0,
                height: participant?.weightIn?.height
                  ? getRoundedNumber(parseFloat(decryptString(participant?.weightIn?.height)))
                  : 0,
                muscleKilogram: participant?.weightIn?.muscleKilogram
                  ? getRoundedNumber(parseFloat(decryptString(participant?.weightIn?.muscleKilogram)))
                  : 0,
                musclePercentage: participant?.weightIn?.musclePercentage
                  ? getRoundedNumber(parseFloat(decryptString(participant?.weightIn?.musclePercentage)))
                  : 0,
                weight: participant?.weightIn?.weight
                  ? getRoundedNumber(parseFloat(decryptString(participant?.weightIn?.weight)))
                  : 0,
              },
              weightOut: {
                ...participant.weightOut,
                bodyFat: participant?.weightOut?.bodyFat
                  ? getRoundedNumber(parseFloat(decryptString(participant?.weightOut?.bodyFat)))
                  : null,
                height: participant?.weightOut?.height
                  ? getRoundedNumber(parseFloat(decryptString(participant?.weightOut?.height)))
                  : null,
                muscleKilogram: participant?.weightOut?.muscleKilogram
                  ? getRoundedNumber(parseFloat(decryptString(participant?.weightOut?.muscleKilogram)))
                  : null,
                musclePercentage: participant?.weightOut?.musclePercentage
                  ? getRoundedNumber(parseFloat(decryptString(participant?.weightOut?.musclePercentage)))
                  : null,
                weight: participant?.weightOut?.weight
                  ? getRoundedNumber(parseFloat(decryptString(participant?.weightOut?.weight)))
                  : null,
              },
              orderStatus: participant?.purchase[0]?.orderStatus === 1 ? 'YES' : 'NO',
              isIndividualAchieved:
                participant?.isIndividualAchieved === 1
                  ? 'YES'
                  : participant.isIndividualAchieved === 0
                    ? 'NO'
                    : 'PENDING',
            }));

            setConfirmCheck(
              participantsWithAcknowledgement.some(
                (participant: DynamicObjectInterface) => participant.acknowledgement,
              ),
            );

            // setTeamLeaderList(
            //   result.data.data?.map((d: DynamicObjectInterface) => ({
            //     value: d.userId,
            //     title: d.name,
            //   })),
            // );
            setParticipantList(participantsWithAcknowledgement);
            setDisplayEmpty(participantsWithAcknowledgement.length === 0);

            allocateTeamRewardsCheck('weightIn', data.campaignId, data.teamId);
            allocateTeamRewardsCheck('weightOut', data.campaignId, data.teamId);
          } else {
            setDisplayEmpty(true);
            LoggerService.log('Failed to retrieve team detail', result.status);
          }
        }
      } else {
        LoggerService.log('Failed to retrieve team detail');
      }
    })();
  }, [id]);

  const handleInputChange = (name: string, value: DynamicObjectInterface) => {
    setTeamData(prevKpiData => ({
      ...prevKpiData!,
      [name]: value,
    }));
  };

  const onSave = async () => {
    const payload = {
      teamName: teamData?.teamName,
      description: teamData?.description,
      teamLeader: teamData?.teamLeader,
      coachId: teamData?.coachId,
      campaignId: teamData?.campaignId,
      teamStartDate: moment(teamData?.teamStartDate).format('YYYY-MM-DD'),
      teamEndDate: moment(teamData?.teamEndDate).format('YYYY-MM-DD'),
      isIndividualTeam: teamData?.isIndividualTeam,
      status: teamData?.status,
      modifiedBy: '',
    };

    const result = await apiCall(TeamService.updateTeam, `${id}`, payload);
    if (result.status === 200) {
      navigate(`/admin/manage-team/edit?=${teamData.teamId}`);
      adminToast({
        message: t('admin.teamEdit.teamUpdateSuccess'),
        theme: Theme.SUCCESS,
      });
    } else {
      adminToast({
        message: t('admin.teamEdit.teamUpdateError') + result?.data?.message,
        theme: Theme.ERROR,
      });
    }
  };

  const teamDetailsBtnConfig = [
    {
      title: t('admin.teamEdit.cancel'),
      buttonStyle: ButtonStyles.SOLID,
      onClick: () => {
        let redirectFrom = sessionStorage.getItem('redirectFrom');
        if (redirectFrom) {
          sessionStorage.removeItem('redirectFrom');
          navigate(redirectFrom);
        } else {
          navigate(`/admin/manage-team/list?campaignId=${teamData.campaignId}`);
        }
      },
    },
    {
      title: t('admin.teamEdit.save'),
      buttonStyle: ButtonStyles.SOLID,
      disabled: !teamData.teamName,
      onClick: onSave,
    },
  ];

  const participantBtnConfig = [
    {
      title: t('admin.teamEdit.allocateWeightInReward'),
      buttonStyle: ButtonStyles.SOLID,
      hidden: !showAllWeightIn,
      onClick: async () => {
        await allocateTeamRewards('weightIn', teamData?.campaignId ?? '', teamData?.teamId ?? 0);
        await allocateTeamRewardsCheck('weightOut', teamData?.campaignId ?? '', teamData?.teamId ?? 0);
      },
    },
    {
      title: t('admin.teamEdit.allocateWeightOutReward'),
      buttonStyle: ButtonStyles.SOLID,
      hidden: !showAllWeightOut,
      onClick: () => {
        allocateTeamRewards('weightOut', teamData?.campaignId ?? '', teamData?.teamId ?? 0);
      },
    },
    {
      title: t('admin.teamEdit.addParticipant'),
      buttonStyle: ButtonStyles.SOLID,
      onClick: () => {
        navigate(`/admin/manage-team/edit/add-participant?=${teamData.teamId}`);
      },
    },
    {
      title: t('admin.teamEdit.shareLink'),
      buttonStyle: ButtonStyles.SOLID,
      onClick: () => {
        generateJoinTeamLink();
      },
    },
  ];

  const generateJoinTeamLink = () => {
    const params = `${teamData.campaignRecId},${teamData.teamId},0`;
    const encodedParam = btoa(params);
    if (teamData.teamId && teamData.campaignRecId) {
      setJoinTeamLink(`${window.location.protocol}//${window.location.host}?source=email&t=${encodedParam}`);
      setShowShareDrawer(true);
    }
  };

  const onEdit = (id: ParticipantDataStructure) => {
    setSelectedRow(id);
    navigate(
      `/admin/manage-team/edit/participant-details?campaignId=${id.campaignId}&teamId=${id.teamId}&userId=${id.userId}`,
    );
  };

  const onClick = (data: ParticipantDataStructure) => {
    setSelectedRow(data);

    const selectedParticipant = participantList.find(
      (participant: DynamicObjectInterface) => participant.userId === data?.userId,
    );
    setRemarksWeightIn(selectedParticipant?.weightIn?.remarks ?? '');
    setRemarksWeightOut(selectedParticipant?.weightOut?.remarks ?? '');

    if (data.weightIn.weightInDate && !data.weightIn.acknowledgeBy) {
      setShowAcknowledgment(true);
      setIsWeightInAcknowledged(true);
    }

    if (data.weightOut.weightOutDate && !data.weightOut.acknowledgeBy) {
      setShowAcknowledgment(true);
      setIsWeightOutAcknowledged(true);
    }
  };

  const searchCoach = (input: string) => {
    if (!input) {
      setFilteredCoachList(coachList);
    } else {
      const filteredUsers = coachList.filter((coach: DropdownOption) => {
        return coach.title.toLowerCase().includes(input.toLowerCase());
      });
      setFilteredCoachList(filteredUsers);
    }
  };

  const acknowledgeParticipant = async () => {
    // Prepare the payload for the PATCH request
    const payload: AcknowledgePayload[] = [];

    if (isWeightInAcknowledged) {
      payload.push({
        userId: selectedRow?.userId,
        campaignId: selectedRow?.campaignId,
        teamId: teamData?.teamId,
        name: selectedRow?.name,
        action: 'WEIGHT_IN',
        acknowledgeDateTime: selectedRow?.weightIn?.acknowledgeDateTime,
        remarks: remarksWeightIn,
      });
    }

    if (isWeightOutAcknowledged) {
      payload.push({
        userId: selectedRow?.userId,
        campaignId: selectedRow?.campaignId,
        teamId: teamData?.teamId,
        name: selectedRow?.name,
        action: 'WEIGHT_OUT',
        acknowledgeDateTime: selectedRow?.weightOut?.acknowledgeDateTime,
        remarks: remarksWeightOut,
      });
    }

    const acknowledgeResponse = await apiCall(AcknowledgementService.acknowledge, `${selectedRow?.userId}`, payload);

    if (acknowledgeResponse.status === 200) {
      setShowAcknowledgment(false);

      // Update acknowledgment status in the client-side state
      const updatedParticipantList = participantList?.map(participant =>
        participant.name === selectedRow?.name ? { ...participant, acknowledgement: true } : participant,
      );
      setParticipantList(updatedParticipantList);

      adminToast({
        message: t('admin.teamEdit.acknowledgeSuccess'),
        theme: Theme.SUCCESS,
      });
      window.location.reload();
    } else {
      adminToast({
        message: t('admin.teamEdit.acknowledgeError'),
        theme: Theme.ERROR,
      });
    }
  };

  const onDelete = (data: ParticipantDataStructure) => {
    setSelectedRow(data);
    setShowDelete(true);
    //setShowDetails(false);
  };

  const onDeleteAction = async () => {
    const parti = {
      teamName: teamData?.teamName,
      teamId: teamData?.teamId,
      campaignId: teamData?.campaignId,
      name: selectedRow?.name,
      loginId: selectedRow?.loginId,
    };

    const result = await apiCall(ParticipantService.deleteTeamParticipant, `${selectedRow?.recId}`, parti);
    if (result.status === 200) {
      LoggerService.log('Participant deleted successfully');
      adminToast({
        message: 'Participant deleted successfully',
        theme: Theme.SUCCESS,
      });
      //fetchTeamList();
      window.location.reload();
    } else {
      LoggerService.log('Error deleting Participant');
      adminToast({
        message: 'Error deleting Participant',
        theme: Theme.ERROR,
      });
    }
    setShowDelete(false);
  };

  useEffect(() => {
    const fetchAuditLogs = async () => {
      try {
        if (teamData?.campaignId && teamData?.teamId) {
          const payload = {
            campaignId: teamData?.campaignId,
            teamId: teamData?.teamId,
          };

          const historyLogResponse = await apiCall(AuditLogService.fetchLog, payload);
          const historyLogResult = historyLogResponse.data;

          setAuditHistoryLog(historyLogResult.data || []);
          setAuditDisplayEmpty(historyLogResult.data.length === 0);
        }
      } catch (error) {
        LoggerService.log('Failed to retrieve audit history log', error);
      }
    };

    fetchAuditLogs();
  }, [teamData?.campaignId, teamData?.teamId]);

  const allocateTeamRewardsCheck = async (allocateType: string, campaignId: string, teamId: number) => {
    const weightPayload = {
      campaignId: campaignId,
      teamId: teamId,
      allocateType: allocateType,
    };

    const allocateWeightInResult = await apiCall(TeamService.getAllocateWeightActionStatus, weightPayload);
    if (allocateWeightInResult.status === 200) {
      let data = allocateWeightInResult.data.result;
      if (allocateType === 'weightIn') {
        setShowAllWeightIn(data);
      } else {
        setShowAllWeightOut(data);
      }
    }
  };

  const allocateTeamRewards = async (allocateType: string, campaignId: string, teamId: number) => {
    const weightPayload = {
      campaignId: campaignId,
      teamId: teamId,
      allocateType: allocateType,
    };

    const allocateRewardResult = await apiCall(TeamService.updateAllocateRewards, weightPayload);
    if (allocateRewardResult.status === 200) {
      let result = allocateRewardResult.data.result;

      if (result) {
        adminToast({
          message: t('admin.teamEdit.allocateWeightOutRewardSuccess'),
          theme: Theme.SUCCESS,
        });
      } else {
        adminToast({
          message: t('admin.teamEdit.allocateWeightOutRewardFailed'),
          theme: Theme.ERROR,
        });
      }

      if (allocateType === 'weightIn') allocateTeamRewardsCheck('weightIn', campaignId, teamId);
      else allocateTeamRewardsCheck('weightOut', campaignId, teamId);
    }
  };

  const acknowledgment = (
    <>
      {showAcknowledgment && (
        <Modal
          primaryButtonLabel={''}
          headline={t('admin.teamEdit.headline')}
          closeIcon={false}
          containerWidth={ipadDimensions ? '750px' : '1000px'}
          textAlign={TextAlign.LEFT}
          primaryButton={
            <Button
              title={t('admin.userSetup.confirm')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                acknowledgeParticipant();
                setShowAcknowledgment(false);
              }}
              disabled={confirmCheck}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
            />
          }
          secondaryButton={
            <Button
              title={t('admin.userSetup.cancel')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                setShowAcknowledgment(false);
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.OUTLINE}
              data-testid="test-cancel-button-popup-delete-modal"
            />
          }
        >
          <div className={styles['participant-confirm-model']}>
            <div className={styles['input-row']}>
              <div className={styles['input-container']}>
                <div className={styles['participant-weight-details']}>Pre-Assessment Measurement</div>
                <table>
                  <tbody>
                    <tr>
                      <td>Name</td>
                      <td className={styles['colon-gap-name']}>:</td>
                      <td>{selectedRow?.name}</td>
                    </tr>
                    <tr>
                      <td>Date</td>
                      <td className={styles['colon-gap-date']}>:</td>
                      <td>
                        {selectedRow?.weightIn?.weightInDate
                          ? dateTimeToCustomFormat(selectedRow.weightIn.weightInDate, 'DD/MM/yyyy HH:mm')
                          : '-'}
                      </td>
                    </tr>
                    <tr>
                      <td>Height</td>
                      <td className={styles['colon-gap-height']}>:</td>
                      <td>{selectedRow?.weightIn?.height ?? '-'}</td>
                    </tr>
                    <tr>
                      <td>Weight</td>
                      <td className={styles['colon-gap-body-weight']}>:</td>
                      <td>{selectedRow?.weightIn?.weight ?? '-'}</td>
                    </tr>
                    <tr>
                      <td>Body Fat</td>
                      <td className={styles['colon-gap-body-fat']}>:</td>
                      <td>{selectedRow?.weightIn?.bodyFat ?? '-'}</td>
                    </tr>
                    <tr>
                      <td>Muscle Mass (kg)</td>
                      <td className={styles['colon-gap-muscle-kg']}>:</td>
                      <td>{selectedRow?.weightIn?.muscleKilogram ?? '-'}</td>
                    </tr>
                    <tr>
                      <td>Muscle Mass (%)</td>
                      <td className={styles['colon-gap-muscle-kg1']}>:</td>
                      <td>{selectedRow?.weightIn?.musclePercentage ?? '-'}</td>
                    </tr>
                    <tr>
                      <td>Acknowledge Date</td>
                      <td className={styles['colon-gap-muscle-kg1']}>:</td>
                      <td>{selectedRow?.weightIn?.acknowledgeDateTime || '-'}</td>
                    </tr>
                    <tr>
                      <td>Remarks (if any)</td>
                      <td className={styles['colon-gap-remarks']}>:</td>
                      <td>
                        <TextArea
                          resize={false}
                          mlpVersion={MLPVersion.ONE}
                          placeholder={'Remarks'}
                          value={remarksWeightIn}
                          onChange={e => {
                            setRemarksWeightIn(e.target.value);
                          }}
                          disabled={!isWeightInAcknowledged}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className={styles['input-container']}>
                <div className={styles['participant-weight-details']}>Post-Assessment Measurement</div>
                <table>
                  <tbody>
                    <tr>
                      <td>Name</td>
                      <td className={styles['colon-gap-name']}>:</td>
                      <td>{selectedRow?.name}</td>
                    </tr>
                    <tr>
                      <td>Date</td>
                      <td className={styles['colon-gap-date']}>:</td>
                      <td>
                        {selectedRow?.weightOut?.weightOutDate
                          ? dateTimeToCustomFormat(selectedRow.weightOut.weightOutDate, 'DD/MM/yyyy HH:mm')
                          : '-'}
                      </td>
                    </tr>
                    <tr>
                      <td>Height</td>
                      <td className={styles['colon-gap-height']}>:</td>
                      <td>{selectedRow?.weightOut?.height ?? '-'}</td>
                    </tr>
                    <tr>
                      <td>Weight</td>
                      <td className={styles['colon-gap-body-weight']}>:</td>
                      <td>{selectedRow?.weightOut?.weight ?? '-'}</td>
                    </tr>
                    <tr>
                      <td>Body Fat</td>
                      <td className={styles['colon-gap-body-fat']}>:</td>
                      <td>{selectedRow?.weightOut?.bodyFat ?? '-'}</td>
                    </tr>
                    <tr>
                      <td>Muscle Mass (kg)</td>
                      <td className={styles['colon-gap-muscle-kg']}>:</td>
                      <td>{selectedRow?.weightOut?.muscleKilogram ?? '-'}</td>
                    </tr>
                    <tr>
                      <td>Muscle Mass (%)</td>
                      <td className={styles['colon-gap-muscle-kg1']}>:</td>
                      <td>{selectedRow?.weightOut?.musclePercentage || '-'}</td>
                    </tr>
                    <tr>
                      <td>Acknowledge Date</td>
                      <td className={styles['colon-gap-muscle-kg1']}>:</td>
                      <td>{selectedRow?.weightOut?.acknowledgeDateTime || '-'}</td>
                    </tr>
                    <tr>
                      <td>Remarks (if any)</td>
                      <td className={styles['colon-gap-remarks']}>:</td>
                      <td>
                        <TextArea
                          resize={false}
                          mlpVersion={MLPVersion.ONE}
                          placeholder={'Remarks'}
                          value={remarksWeightOut}
                          onChange={e => {
                            setRemarksWeightOut(e.target.value);
                          }}
                          disabled={!isWeightOutAcknowledged}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className={styles['input-row']}>
              <div className={styles['checkbox-container']}>
                <div className={styles['confirmation-checkbox']}>
                  <Checkbox text="" checked={!confirmCheck} onChange={() => setConfirmCheck(!confirmCheck)} />
                  <div className={styles['confirmation-text']}>I verify that the information above is accurate.</div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );

  const deletePrompt = (
    <>
      {showDelete && (
        <Modal
          primaryButtonLabel={''}
          headline={''}
          closeIcon={false}
          containerWidth={'460px'}
          primaryButton={
            <Button
              title={t('admin.teams.confirm')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                onDeleteAction();
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
            />
          }
          secondaryButton={
            <Button
              title={t('admin.teams.cancel')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                setShowDelete(false);
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.OUTLINE}
              theme={Theme.BLACK}
              data-testid="test-cancel-button-popup-delete-modal"
            />
          }
        >
          <>
            <div className={styles['edit-team-delete-title']}>{t('admin.teams.deleteParticipant')}</div>
            <span>ABO ID:{selectedRow?.loginId ?? '-'}</span>
            <br />
            <span> Name: {selectedRow?.name ?? '-'}</span>
          </>
        </Modal>
      )}
    </>
  );

  const sharePrompt = (
    <>
      {showShareDrawer && (
        <ShareDrawer
          open={!!joinTeamLink}
          onClose={() => setShowShareDrawer(false)}
          title="Share Via"
          programMessage={`You have been invited to join ${teamData?.campaignName} at ${joinTeamLink}`}
          programUrl={joinTeamLink}
          channels={['FaWhatsapp', 'FaEnvelope', 'FaLink']}
          programTitle=""
        />
      )}
    </>
  );

  return (
    <div className={styles['edit-team']}>
      <Card title={t('admin.teamEdit.title')} button={teamDetailsBtnConfig}>
        <div className={styles['edit-team-details']}>
          <div className={`${styles['edit-team-details-form']} ${styles['campaign-info']}`}>
            <Input
              key={id}
              type={InputTypes.TEXT}
              name={'campaignId'}
              disabled={true}
              label={t('admin.teams.campaignId')}
              value={teamData?.campaignId ?? ''}
              mlpVersion={MLPVersion.ONE}
            />
            <Input
              key={id}
              type={InputTypes.TEXT}
              name={'campaignName'}
              disabled={true}
              label={t('admin.teams.campaignName')}
              value={teamData?.campaignName ?? ''}
              mlpVersion={MLPVersion.ONE}
            />
            <Input
              key={id}
              type={InputTypes.TEXT}
              name={'campaignPeriod'}
              disabled={true}
              label={t('admin.teams.campaignPeriod')}
              value={`${dateTimeToCustomFormat(teamData?.campaignStart)} - ${dateTimeToCustomFormat(
                teamData?.campaignEnd,
              )}`}
              mlpVersion={MLPVersion.ONE}
            />
          </div>
          <hr className={styles['horizontal-divider']} />
          <div className={`${styles['edit-team-details-form']}`}>
            <div className={styles['form-verticle-spacing']}>
              <Input
                key={id}
                type={InputTypes.TEXT}
                name={'teamName'}
                label={`${t('admin.teams.teamName')}*`}
                placeholder={`${t('admin.teams.teamName')}`}
                value={teamData?.teamName}
                mlpVersion={MLPVersion.ONE}
                onChange={e => {
                  handleInputChange('teamName', e.target.value);
                }}
              />
              <div className={styles['input-status']}>
                <span className={styles['input-label']}>{t('admin.teams.isIndividualTeam')}</span>
                <div className={styles['input-radio']}>
                  <RadioButton
                    label="Team"
                    checked={teamData?.isIndividualTeam !== 1}
                    value={0}
                    disabled
                    onChange={e => handleInputChange('isIndividualTeam', Number(e.target.value))}
                  />
                  <RadioButton
                    label="Individual"
                    checked={teamData?.isIndividualTeam === 1}
                    value={1}
                    disabled
                    onChange={e => handleInputChange('isIndividualTeam', Number(e.target.value))}
                  />
                </div>
              </div>
              <TextArea
                mlpVersion={MLPVersion.ONE}
                label={t('admin.teams.description')}
                placeholder={t('admin.teams.description')}
                value={teamData?.description}
                onChange={e => {
                  handleInputChange('description', e.target.value);
                }}
              />
              {/* <div className={styles['input-dropdown']}>
                <DropDown
                  name={'teamLeader'}
                  dropdownLabel={t('admin.teams.teamLeader')}
                  placeholder={t('admin.teams.teamLeader')}
                  disabledFilter
                  mlpVersion={MLPVersion.ONE}
                  value={teamLeaderList.find(c => c.value === teamData?.teamLeader)?.title}
                  data={teamLeaderList}
                  configData={{
                    label: 'title',
                    onSelect: (selectedOption: DropDownData) => {
                      handleInputChange('teamLeader', selectedOption.value);
                    },
                  }}
                />
              </div> */}
            </div>
            <div className={styles['form-verticle-spacing']}>
              <div className={styles['input-dropdown']}>
                <SearchComponent
                  status={InputValidations.DEFAULT}
                  label={t('admin.teams.coach')}
                  placeholder={t('admin.teams.searchCoach')}
                  initialSearchText={
                    coachList.find(
                      c =>
                        String(c.id ?? '')
                          .toUpperCase()
                          .trim() ===
                        String(teamData?.coachId ?? '')
                          .toUpperCase()
                          .trim(),
                    )?.title
                  }
                  labelChoice={'title'}
                  dropdownOptions={filteredCoachList}
                  onSearch={searchCoach}
                  onClear={() => {
                    searchCoach('');
                    handleInputChange('coachId', '');
                  }}
                  onSelect={e => {
                    handleInputChange('coachId', e.id);
                  }}
                />
              </div>
              <div className={styles['input-period']}>
                <DatePicker
                  showDateContainer
                  containerWidth="450px"
                  inputContainerHeight="36px"
                  calendarHeading={t('admin.teams.teamStartDate')}
                  value={teamData?.teamStartDate ? new Date(teamData?.teamStartDate) : undefined}
                  onChange={date => handleInputChange('teamStartDate', formatISODate(date ?? ''))}
                  inputLabel={t('admin.teams.teamStartDate')}
                  placeholder={t('admin.teams.teamStartDate')}
                />
                <DatePicker
                  showDateContainer
                  inputContainerHeight="36px"
                  containerWidth="450px"
                  calendarContainerStyling={{ right: '0px' }}
                  calendarHeading={t('admin.teams.teamEndDate')}
                  value={teamData?.teamEndDate ? new Date(teamData?.teamEndDate) : undefined}
                  onChange={date => handleInputChange('teamEndDate', formatISODate(date ?? ''))}
                  inputLabel={t('admin.teams.teamEndDate')}
                  placeholder={t('admin.teams.teamEndDate')}
                />
              </div>
              <div className={styles['input-status']}>
                <span className={styles['input-label']}>{t('admin.teams.status')}</span>
                <div className={styles['input-radio']}>
                  <RadioButton
                    label="Active"
                    checked={teamData?.status === 'ACTIVE'}
                    value={'ACTIVE'}
                    onChange={e => handleInputChange('status', e.target.value)}
                  />
                  <RadioButton
                    label="Inactive"
                    checked={teamData?.status === 'INACTIVE'}
                    value={'INACTIVE'}
                    onChange={e => handleInputChange('status', e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
      <Card title={t('admin.teamEdit.participant')} button={participantBtnConfig}>
        {displayEmpty ? (
          <div className={styles['no-results-container']}>
            <OperationCenterErrorCard errorType={ErrorType.NO_RECORD} />
          </div>
        ) : (
          <div>
            <TableContainer
              dataSource={participantList}
              getColumns={getParticipantListConfig}
              rowKey="name"
              selected={selectedRow?.name}
              cb={{ onEdit, onDelete, onClick }}
              onRowClick={row => {
                setSelectedRow(row);
              }}
            />
          </div>
        )}
      </Card>
      <AuditHistoryAccordion auditHistoryLog={auditHistoryLog} displayAuditEmpty={displayAuditEmpty} />
      {acknowledgment}
      {deletePrompt}
      {sharePrompt}
    </div>
  );
};
